/*
It is recommended to install the following plugin when working on this file with VS Code: "#region folding for VS Code"
filteredJobs wordt gerenderd in het frontend.
*/
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    loading: true, // shows or hides the spinner.
    sortOptions: ["Datum nieuwste eerst", "Datum oudste eerst"],
    sortBy: "",
    fullTimeSelected: Boolean,
    partTimeSelected: Boolean,
    otherTimeSelected: Boolean,
    selectedPlaces: [],
    selectedRegions: [],
    selectedContractTypes: [],
    selectedIndustries: [],
    selectedEducationLevels: [],
    collapsedRegions: [],
    miscData: {},
    // -1 means the input.value = ""
    // Initial object because the app will otherwise try to render without data and consequently errors will occur.
    allJobs: [
      {
        "Id": -1,
        "UrlSegment": "",
        "JobFunction": "",
        "Region": "",
        "Place": "",
        "Industry": "",
        "ContractType": "",
        "Contact": {
            "FirstName": "",
            "LastName": "",
            "Description": "",
            "Image": "",
            "EmailAddress": "",
            "PhoneNumber": ""
        },
        "EducationLevel": "",
        "Image": ""
    },
    ]
    // allJobs: [
    //   {
    //     Id: 1,
    //     UrlSegment: "vacature1",
    //     Title: "title1",
    //     Description: "Description1",
    //     JobFunction: "omglol1",
    //     Area: null,
    //     Industry: "Horeca",
    //     ContractType: "Parttime",
    //     EducationLevel: "VMBO",
    //     Region: "Noord Holland",
    //     Place: "Hilversum",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 2,
    //     UrlSegment: "vacature2",
    //     Title: "title2",
    //     Description: "Description2",
    //     JobFunction: "omglol2",
    //     Area: null,
    //     Industry: "Horeca",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VMBO",
    //     Region: "Utrecht",
    //     Place: "Leerdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 3,
    //     UrlSegment: "vacature3",
    //     Title: "title3",
    //     Description: "Description3",
    //     JobFunction: "omglol3",
    //     Area: null,
    //     Industry: "Zorg",
    //     ContractType: "Fulltime",
    //     EducationLevel: "VMBO",
    //     Region: "Groningen",
    //     Place: "Hoogezand",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 4,
    //     UrlSegment: "vacature4",
    //     Title: "title4",
    //     Description: "Description4",
    //     JobFunction: "omglol4",
    //     Area: null,
    //     Industry: "Finance",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VMBO",
    //     Region: "Brabant",
    //     Place: "Tilburg",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 5,
    //     UrlSegment: "vacature5",
    //     Title: "title5",
    //     Description: "Description5",
    //     JobFunction: "omglol5",
    //     Area: null,
    //     Industry: "Finance",
    //     ContractType: "Fulltime",
    //     EducationLevel: "VWO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 6,
    //     UrlSegment: "vacature6",
    //     Title: "title6",
    //     Description: "Description6",
    //     JobFunction: "omglol6",
    //     Area: null,
    //     Industry: "Agrarisch",
    //     ContractType: "Fulltime",
    //     EducationLevel: "HAVO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 7,
    //     UrlSegment: "vacature7",
    //     Title: "title7",
    //     Description: "Description7",
    //     JobFunction: "omglol7",
    //     Area: null,
    //     Industry: "Klantenservice",
    //     ContractType: "Fulltime",
    //     EducationLevel: "HAVO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 8,
    //     UrlSegment: "vacature8",
    //     Title: "title8",
    //     Description: "Description8",
    //     JobFunction: "omglol8",
    //     Area: null,
    //     Industry: "Finance",
    //     ContractType: "Onbekend",
    //     EducationLevel: "HAVO",
    //     Region: "Overijssel",
    //     Place: "Zwolle",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 9,
    //     UrlSegment: "vacature9",
    //     Title: "title9",
    //     Description: "Description9",
    //     JobFunction: "omglol9",
    //     Area: null,
    //     Industry: "Overig",
    //     ContractType: "Parttime",
    //     EducationLevel: "VWO",
    //     Region: "Overijssel",
    //     Place: "Zwolle",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 10,
    //     UrlSegment: "vacature10",
    //     Title: "title10",
    //     Description: "Description10",
    //     JobFunction: "omglol10",
    //     Area: null,
    //     Industry: "Sales",
    //     ContractType: "Parttime",
    //     EducationLevel: "VMBO",
    //     Region: "Groningen",
    //     Place: "Groningen",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 11,
    //     UrlSegment: "vacature11",
    //     Title: "title11",
    //     Description: "Description11",
    //     JobFunction: "omglol11",
    //     Area: null,
    //     Industry: "Klantenservice",
    //     ContractType: "Parttime",
    //     EducationLevel: "VMBO",
    //     Region: "Overijssel",
    //     Place: "Zwolle",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 12,
    //     UrlSegment: "vacature12",
    //     Title: "title12",
    //     Description: "Description12",
    //     JobFunction: "omglol12",
    //     Area: null,
    //     Industry: "ICT",
    //     ContractType: "Onbekend",
    //     EducationLevel: "HAVO",
    //     Region: "Noord Holland",
    //     Place: "Hilversum",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 13,
    //     UrlSegment: "vacature13",
    //     Title: "title13",
    //     Description: "Description13",
    //     JobFunction: "omglol13",
    //     Area: null,
    //     Industry: "Finance",
    //     ContractType: "Parttime",
    //     EducationLevel: "HAVO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 14,
    //     UrlSegment: "vacature14",
    //     Title: "title14",
    //     Description: "Description14",
    //     JobFunction: "omglol14",
    //     Area: null,
    //     Industry: "ICT",
    //     ContractType: "Onbekend",
    //     EducationLevel: "HAVO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 15,
    //     UrlSegment: "vacature15",
    //     Title: "title15",
    //     Description: "Description15",
    //     JobFunction: "omglol15",
    //     Area: null,
    //     Industry: "Klantenservice",
    //     ContractType: "Parttime",
    //     EducationLevel: "HAVO",
    //     Region: "Overijssel",
    //     Place: "Zwolle",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 16,
    //     UrlSegment: "vacature16",
    //     Title: "title16",
    //     Description: "Description16",
    //     JobFunction: "omglol16",
    //     Area: null,
    //     Industry: "Sales",
    //     ContractType: "Fulltime",
    //     EducationLevel: "HAVO",
    //     Region: "Utrecht",
    //     Place: "Amersfoort",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 17,
    //     UrlSegment: "vacature17",
    //     Title: "title17",
    //     Description: "Description17",
    //     JobFunction: "omglol17",
    //     Area: null,
    //     Industry: "Overig",
    //     ContractType: "Parttime",
    //     EducationLevel: "VMBO",
    //     Region: "Utrecht",
    //     Place: "Leerdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 18,
    //     UrlSegment: "vacature18",
    //     Title: "title18",
    //     Description: "Description18",
    //     JobFunction: "omglol18",
    //     Area: null,
    //     Industry: "Horeca",
    //     ContractType: "Parttime",
    //     EducationLevel: "HAVO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 19,
    //     UrlSegment: "vacature19",
    //     Title: "title19",
    //     Description: "Description19",
    //     JobFunction: "omglol19",
    //     Area: null,
    //     Industry: "Zorg",
    //     ContractType: "Onbekend",
    //     EducationLevel: "HAVO",
    //     Region: "Noord Holland",
    //     Place: "Hilversum",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 20,
    //     UrlSegment: "vacature20",
    //     Title: "title20",
    //     Description: "Description20",
    //     JobFunction: "omglol20",
    //     Area: null,
    //     Industry: "Sales",
    //     ContractType: "Parttime",
    //     EducationLevel: "VWO",
    //     Region: "Utrecht",
    //     Place: "Zeist",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 21,
    //     UrlSegment: "vacature21",
    //     Title: "title21",
    //     Description: "Description21",
    //     JobFunction: "omglol21",
    //     Area: null,
    //     Industry: "Zorg",
    //     ContractType: "Parttime",
    //     EducationLevel: "VWO",
    //     Region: "Noord Holland",
    //     Place: "Hilversum",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 22,
    //     UrlSegment: "vacature22",
    //     Title: "title22",
    //     Description: "Description22",
    //     JobFunction: "omglol22",
    //     Area: null,
    //     Industry: "Finance",
    //     ContractType: "Parttime",
    //     EducationLevel: "VWO",
    //     Region: "Noord Holland",
    //     Place: "Hilversum",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 23,
    //     UrlSegment: "vacature23",
    //     Title: "title23",
    //     Description: "Description23",
    //     JobFunction: "omglol23",
    //     Area: null,
    //     Industry: "Finance",
    //     ContractType: "Onbekend",
    //     EducationLevel: "HAVO",
    //     Region: "Utrecht",
    //     Place: "Leerdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 24,
    //     UrlSegment: "vacature24",
    //     Title: "title24",
    //     Description: "Description24",
    //     JobFunction: "omglol24",
    //     Area: null,
    //     Industry: "Klantenservice",
    //     ContractType: "Fulltime",
    //     EducationLevel: "VWO",
    //     Region: "Noord Holland",
    //     Place: "Hilversum",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 25,
    //     UrlSegment: "vacature25",
    //     Title: "title25",
    //     Description: "Description25",
    //     JobFunction: "omglol25",
    //     Area: null,
    //     Industry: "ICT",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VMBO",
    //     Region: "Utrecht",
    //     Place: "Zeist",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 26,
    //     UrlSegment: "vacature26",
    //     Title: "title26",
    //     Description: "Description26",
    //     JobFunction: "omglol26",
    //     Area: null,
    //     Industry: "Finance",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VMBO",
    //     Region: "Noord Holland",
    //     Place: "Hilversum",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 27,
    //     UrlSegment: "vacature27",
    //     Title: "title27",
    //     Description: "Description27",
    //     JobFunction: "omglol27",
    //     Area: null,
    //     Industry: "Administratief",
    //     ContractType: "Fulltime",
    //     EducationLevel: "VWO",
    //     Region: "Noord Holland",
    //     Place: "Hilversum",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 28,
    //     UrlSegment: "vacature28",
    //     Title: "title28",
    //     Description: "Description28",
    //     JobFunction: "omglol28",
    //     Area: null,
    //     Industry: "Horeca",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VWO",
    //     Region: "Utrecht",
    //     Place: "Zeist",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 29,
    //     UrlSegment: "vacature29",
    //     Title: "title29",
    //     Description: "Description29",
    //     JobFunction: "omglol29",
    //     Area: null,
    //     Industry: "Sales",
    //     ContractType: "Parttime",
    //     EducationLevel: "VMBO",
    //     Region: "Overijssel",
    //     Place: "Zwolle",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 30,
    //     UrlSegment: "vacature30",
    //     Title: "title30",
    //     Description: "Description30",
    //     JobFunction: "omglol30",
    //     Area: null,
    //     Industry: "Sales",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VMBO",
    //     Region: "Utrecht",
    //     Place: "Amersfoort",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 31,
    //     UrlSegment: "vacature31",
    //     Title: "title31",
    //     Description: "Description31",
    //     JobFunction: "omglol31",
    //     Area: null,
    //     Industry: "ICT",
    //     ContractType: "Fulltime",
    //     EducationLevel: "HAVO",
    //     Region: "Utrecht",
    //     Place: "Zeist",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 32,
    //     UrlSegment: "vacature32",
    //     Title: "title32",
    //     Description: "Description32",
    //     JobFunction: "omglol32",
    //     Area: null,
    //     Industry: "Finance",
    //     ContractType: "Parttime",
    //     EducationLevel: "HAVO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 33,
    //     UrlSegment: "vacature33",
    //     Title: "title33",
    //     Description: "Description33",
    //     JobFunction: "omglol33",
    //     Area: null,
    //     Industry: "Administratief",
    //     ContractType: "Parttime",
    //     EducationLevel: "HAVO",
    //     Region: "Groningen",
    //     Place: "Groningen",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 34,
    //     UrlSegment: "vacature34",
    //     Title: "title34",
    //     Description: "Description34",
    //     JobFunction: "omglol34",
    //     Area: null,
    //     Industry: "ICT",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VMBO",
    //     Region: "Noord Holland",
    //     Place: "Hilversum",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 35,
    //     UrlSegment: "vacature35",
    //     Title: "title35",
    //     Description: "Description35",
    //     JobFunction: "omglol35",
    //     Area: null,
    //     Industry: "Sales",
    //     ContractType: "Onbekend",
    //     EducationLevel: "HAVO",
    //     Region: "Utrecht",
    //     Place: "Zeist",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 36,
    //     UrlSegment: "vacature36",
    //     Title: "title36",
    //     Description: "Description36",
    //     JobFunction: "omglol36",
    //     Area: null,
    //     Industry: "Administratief",
    //     ContractType: "Parttime",
    //     EducationLevel: "HAVO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 37,
    //     UrlSegment: "vacature37",
    //     Title: "title37",
    //     Description: "Description37",
    //     JobFunction: "omglol37",
    //     Area: null,
    //     Industry: "Zorg",
    //     ContractType: "Fulltime",
    //     EducationLevel: "VMBO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 38,
    //     UrlSegment: "vacature38",
    //     Title: "title38",
    //     Description: "Description38",
    //     JobFunction: "omglol38",
    //     Area: null,
    //     Industry: "Administratief",
    //     ContractType: "Parttime",
    //     EducationLevel: "HAVO",
    //     Region: "Utrecht",
    //     Place: "Zeist",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 39,
    //     UrlSegment: "vacature39",
    //     Title: "title39",
    //     Description: "Description39",
    //     JobFunction: "omglol39",
    //     Area: null,
    //     Industry: "Zorg",
    //     ContractType: "Fulltime",
    //     EducationLevel: "HAVO",
    //     Region: "Noord Holland",
    //     Place: "Hilversum",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 40,
    //     UrlSegment: "vacature40",
    //     Title: "title40",
    //     Description: "Description40",
    //     JobFunction: "omglol40",
    //     Area: null,
    //     Industry: "Zorg",
    //     ContractType: "Fulltime",
    //     EducationLevel: "VMBO",
    //     Region: "Overijssel",
    //     Place: "Zwolle",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 41,
    //     UrlSegment: "vacature41",
    //     Title: "title41",
    //     Description: "Description41",
    //     JobFunction: "omglol41",
    //     Area: null,
    //     Industry: "Overig",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VMBO",
    //     Region: "Groningen",
    //     Place: "Baflo",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 42,
    //     UrlSegment: "vacature42",
    //     Title: "title42",
    //     Description: "Description42",
    //     JobFunction: "omglol42",
    //     Area: null,
    //     Industry: "Klantenservice",
    //     ContractType: "Parttime",
    //     EducationLevel: "VMBO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 43,
    //     UrlSegment: "vacature43",
    //     Title: "title43",
    //     Description: "Description43",
    //     JobFunction: "omglol43",
    //     Area: null,
    //     Industry: "Zorg",
    //     ContractType: "Fulltime",
    //     EducationLevel: "VWO",
    //     Region: "Groningen",
    //     Place: "Baflo",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 44,
    //     UrlSegment: "vacature44",
    //     Title: "title44",
    //     Description: "Description44",
    //     JobFunction: "omglol44",
    //     Area: null,
    //     Industry: "ICT",
    //     ContractType: "Onbekend",
    //     EducationLevel: "HAVO",
    //     Region: "Utrecht",
    //     Place: "Amersfoort",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 45,
    //     UrlSegment: "vacature45",
    //     Title: "title45",
    //     Description: "Description45",
    //     JobFunction: "omglol45",
    //     Area: null,
    //     Industry: "Zorg",
    //     ContractType: "Fulltime",
    //     EducationLevel: "VWO",
    //     Region: "Overijssel",
    //     Place: "Zwolle",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 46,
    //     UrlSegment: "vacature46",
    //     Title: "title46",
    //     Description: "Description46",
    //     JobFunction: "omglol46",
    //     Area: null,
    //     Industry: "Horeca",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VWO",
    //     Region: "Noord Holland",
    //     Place: "Amsterdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 47,
    //     UrlSegment: "vacature47",
    //     Title: "title47",
    //     Description: "Description47",
    //     JobFunction: "omglol47",
    //     Area: null,
    //     Industry: "Sales",
    //     ContractType: "Fulltime",
    //     EducationLevel: "HAVO",
    //     Region: "Overijssel",
    //     Place: "Zwolle",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 48,
    //     UrlSegment: "vacature48",
    //     Title: "title48",
    //     Description: "Description48",
    //     JobFunction: "omglol48",
    //     Area: null,
    //     Industry: "Klantenservice",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VWO",
    //     Region: "Utrecht",
    //     Place: "Leerdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 49,
    //     UrlSegment: "vacature49",
    //     Title: "title49",
    //     Description: "Description49",
    //     JobFunction: "omglol49",
    //     Area: null,
    //     Industry: "Overig",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VWO",
    //     Region: "Groningen",
    //     Place: "Baflo",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   },
    //   {
    //     Id: 50,
    //     UrlSegment: "vacature50",
    //     Title: "title50",
    //     Description: "Description50",
    //     JobFunction: "omglol50",
    //     Area: null,
    //     Industry: "Horeca",
    //     ContractType: "Onbekend",
    //     EducationLevel: "VWO",
    //     Region: "Utrecht",
    //     Place: "Leerdam",
    //     Images: "/media/1008/placeholderauto800x600.png"
    //   }
    // ]
  },
  actions: {
    /*
     Get all the jobs from the umbraco api and store them in the jobs list
    */
    async load(context) {
      var result = await axios.get("/umbraco/api/jobs/GetJobModuleData");
      context.commit("mutateAllJobs", result.data.Jobs);
      context.commit("mutateMiscData", result.data.MiscData);
      context.commit("mutateLoading", false);
    }
    // async loading(context) {
    //   context.commit("mutateLoading", true);
    //   setTimeout(function() {
    //     context.commit("mutateLoading", false);
    //   }, 500);
    // }
  },
  mutations: {
    addCollapsedRegion(state, toggledRegion) {
      if (state.collapsedRegions.includes(toggledRegion)) {
        state.collapsedRegions = state.collapsedRegions.filter(
          region => region != toggledRegion
        );
      } else {
        state.collapsedRegions.push(toggledRegion);
      }
    },
    mutateLoading(state, payload) {
      state.loading = payload;
    },
    mutateSortBy(state, payload) {
      state.sortBy = payload;
    },
    mutateAllJobs(state, payload) {
      state.allJobs = payload;
    },
    mutateSelectedContractTypes(state, payload) {
      state.selectedContractTypes = payload;
    },
    mutateSelectedIndustries(state, payload) {
      state.selectedIndustries = payload;
    },
    mutateSelectedEducationLevels(state, payload) {
      state.selectedEducationLevels = payload;
    },
    mutateSelectedPlaces(state, payload) {
      state.selectedPlaces = payload;
    },
    mutateSelectedRegions(state, payload) {
      state.selectedRegions = payload;
    },
    mutateMiscData(state, payload) {
      state.miscData = payload;
    }
  },
  getters: {
    // returns true when there are no jobs in filteredJobs.
    noResults: (state, getters) => {
      if (getters.filteredJobs != undefined) {
        if (getters.filteredJobs.length == 0) {
          return true;
        }
      } else {
        return false;
      }
    },
    // Sorts a list of jobs by the selected sortoption.
    contractTypes: state => {
      let contractType = [];
      for (var i = 0; i < state.allJobs.length; i++) {
        if (state.allJobs[i].ContractType) {
          contractType.push(state.allJobs[i].ContractType);
        }
      }

      // A Set can only contain unique values so duplicates are removed from the array.
      contractType.sort(); // Todo directly use Set
      contractType = [...new Set(contractType)];
      return contractType;
    },
    filteredByContractTypes(state, getters) {
      let filteredByContractTypes = [];
      if (state.selectedContractTypes.length == 0) {
        filteredByContractTypes = state.allJobs;
      } else {
        state.selectedContractTypes.forEach(contractType => {
          filteredByContractTypes = filteredByContractTypes.concat(
            state.allJobs.filter(job => job.ContractType == contractType)
          );
        });
      }
      return filteredByContractTypes;
    },

    contractTypeOptions: (state, getters) => {
      let contractTypesJobs = getContractTypes(state.allJobs);

      let contractTypeOptions = getContractTypeOptions(contractTypesJobs);

      function getContractTypes(jobsArray) {
        let contractTypes = [];
        for (var i = 0; i < jobsArray.length; i++) {
          if (jobsArray[i].ContractType) {
            contractTypes.push(jobsArray[i].ContractType);
          }
        }
        contractTypes.sort();
        contractTypes = [...new Set(contractTypes)];
        contractTypes = Array.from(contractTypes);
        return contractTypes;
      }
      // returns a contractTypeOption for each contractType
      function getContractTypeOptions(contractTypesJobs) {
        let contractTypeOptions = [];
        contractTypesJobs.forEach(contractType => {
          let contractTypeOption = {
            value: "",
            text: "",
            disabled: false,
            count: 0
          };

          var countInNotFilteredByContractTypes = 0;
          for (var i = 0; i < getters.notFilteredByContractTypes.length; ++i) {
            if (
              getters.notFilteredByContractTypes[i].ContractType == contractType
            ) {
              countInNotFilteredByContractTypes++;
            }
          }
          contractTypeOption.value = contractType;
          contractTypeOption.text = contractType;
          contractTypeOption.count = countInNotFilteredByContractTypes;
          if (contractTypeOption.count == 0) {
            contractTypeOption.disabled = true;
          }
          contractTypeOptions.push(contractTypeOption);
        });
        return contractTypeOptions;
      }
      return contractTypeOptions;
    },
    notFilteredByContractTypes(state, getters) {
      let notFilteredByContractTypes;
      let array1 = getters.filteredByIndustries;
      let array2 = getters.filteredByEducationLevels;
      let array3 = getters.filteredByPlaces;
      notFilteredByContractTypes = array1.filter(function(n) {
        for (var i = 0; i < array2.length; i++) {
          if (n.Id == array2[i].Id) {
            return true;
          }
        }
        return false;
      });
      notFilteredByContractTypes = notFilteredByContractTypes.filter(function(
        n
      ) {
        for (var i = 0; i < array3.length; i++) {
          if (n.Id == array3[i].Id) {
            return true;
          }
        }
        return false;
      });
      return notFilteredByContractTypes;
    },

    industries: state => {
      let industry = [];
      for (var i = 0; i < state.allJobs.length; i++) {
        if (state.allJobs[i].Industry) {
          industry.push(state.allJobs[i].Industry);
        }
      }

      // A Set can only contain unique values so duplicates are removed from the array.
      industry.sort(); // Todo directly use Set
      industry = [...new Set(industry)];
      return industry;
    },
    filteredByIndustries(state, getters) {
      let filteredByIndustries = [];
      if (state.selectedIndustries.length == 0) {
        filteredByIndustries = state.allJobs;
      } else {
        state.selectedIndustries.forEach(industry => {
          filteredByIndustries = filteredByIndustries.concat(
            state.allJobs.filter(job => job.Industry == industry)
          );
        });
      }
      return filteredByIndustries;
    },

    industryOptions: (state, getters) => {
      let industriesJobs = getIndustries(state.allJobs);
      let industryOptions = getIndustryOptions(industriesJobs);

      function getIndustries(jobsArray) {
        let industries = [];
        for (var i = 0; i < jobsArray.length; i++) {
          if (jobsArray[i].Industry) {
            industries.push(jobsArray[i].Industry);
          }
        }
        industries.sort();
        industries = [...new Set(industries)];
        industries = Array.from(industries);
        return industries;
      }
      // returns a industryOption for each industry
      function getIndustryOptions(industriesJobs, industriesFilteredJobs) {
        let industryOptions = [];
        industriesJobs.forEach(industry => {
          let industryOption = {
            value: "",
            text: "",
            disabled: false,
            count: 0
          };

          var countInNotFilteredByIndustries = 0;
          for (var i = 0; i < getters.notFilteredByIndustries.length; ++i) {
            if (getters.notFilteredByIndustries[i].Industry == industry) {
              countInNotFilteredByIndustries++;
            }
          }
          industryOption.value = industry;
          industryOption.text = industry;
          industryOption.count = countInNotFilteredByIndustries;
          if (industryOption.count == 0) {
            industryOption.disabled = true;
          }
          industryOptions.push(industryOption);
        });
        return industryOptions;
      }
      return industryOptions;
    },
    notFilteredByIndustries(state, getters) {
      let notFilteredByIndustries;
      let array1 = getters.filteredByContractTypes;
      let array2 = getters.filteredByEducationLevels;
      let array3 = getters.filteredByPlaces;
      notFilteredByIndustries = array1.filter(function(n) {
        for (var i = 0; i < array2.length; i++) {
          if (n.Id == array2[i].Id) {
            return true;
          }
        }
        return false;
      });
      notFilteredByIndustries = notFilteredByIndustries.filter(function(n) {
        for (var i = 0; i < array3.length; i++) {
          if (n.Id == array3[i].Id) {
            return true;
          }
        }
        return false;
      });
      return notFilteredByIndustries;
    },
    educationLevels: state => {
      let educationLevel = [];
      for (var i = 0; i < state.allJobs.length; i++) {
        if (state.allJobs[i].EducationLevel) {
          educationLevel.push(state.allJobs[i].EducationLevel);
        }
      }

      // A Set can only contain unique values so duplicates are removed from the array.
      educationLevel.sort(); // Todo directly use Set
      educationLevel = [...new Set(educationLevel)];
      return educationLevel;
    },
    filteredByEducationLevels(state, getters) {
      let filteredByEducationLevels = [];
      if (state.selectedEducationLevels.length == 0) {
        filteredByEducationLevels = state.allJobs;
      } else {
        state.selectedEducationLevels.forEach(educationLevel => {
          filteredByEducationLevels = filteredByEducationLevels.concat(
            state.allJobs.filter(job => job.EducationLevel == educationLevel)
          );
        });
      }
      return filteredByEducationLevels;
    },

    educationLevelOptions: (state, getters) => {
      let educationLevelsJobs = getters.educationLevels;
      let educationLevelOptions = getEducationLevelOptions(educationLevelsJobs);

      function getEducationLevels(jobsArray) {
        let educationLevels = [];
        for (var i = 0; i < jobsArray.length; i++) {
          if (jobsArray[i].EducationLevel) {
            educationLevels.push(jobsArray[i].EducationLevel);
          }
        }
        educationLevels.sort();
        educationLevels = [...new Set(educationLevels)];
        educationLevels = Array.from(educationLevels);
        return educationLevels;
      }
      // returns a educationLevelOption for each educationLevel
      function getEducationLevelOptions(educationLevelsJobs) {
        let educationLevelOptions = [];
        educationLevelsJobs.forEach(educationLevel => {
          let educationLevelOption = {
            value: "",
            text: "",
            disabled: false,
            count: 0
          };

          var countInNotFilteredByEducationLevels = 0;
          for (
            var i = 0;
            i < getters.notFilteredByEducationLevels.length;
            ++i
          ) {
            if (
              getters.notFilteredByEducationLevels[i].EducationLevel ==
              educationLevel
            ) {
              countInNotFilteredByEducationLevels++;
            }
          }
          educationLevelOption.value = educationLevel;
          educationLevelOption.text = educationLevel;
          educationLevelOption.count = countInNotFilteredByEducationLevels;
          if (educationLevelOption.count == 0) {
            educationLevelOption.disabled = true;
          }
          educationLevelOptions.push(educationLevelOption);
        });
        return educationLevelOptions;
      }
      return educationLevelOptions;
    },
    notFilteredByEducationLevels(state, getters) {
      let notFilteredByEducationLevels;
      let array1 = getters.filteredByIndustries;
      let array2 = getters.filteredByContractTypes;
      let array3 = getters.filteredByPlaces;
      notFilteredByEducationLevels = array1.filter(function(n) {
        for (var i = 0; i < array2.length; i++) {
          if (n.Id == array2[i].Id) {
            return true;
          }
        }
        return false;
      });
      notFilteredByEducationLevels = notFilteredByEducationLevels.filter(
        function(n) {
          for (var i = 0; i < array3.length; i++) {
            if (n.Id == array3[i].Id) {
              return true;
            }
          }
          return false;
        }
      );
      return notFilteredByEducationLevels;
    },
    regions: state => {
      let region = [];
      for (var i = 0; i < state.allJobs.length; i++) {
        if (state.allJobs[i].Region) {
          region.push(state.allJobs[i].Region);
        }
      }

      // A Set can only contain unique values so duplicates are removed from the array.
      region.sort(); // Todo directly use Set
      region = [...new Set(region)];
      return region;
    },
    filteredByPlaces(state, getters) {
      let filteredByPlaces = [];
      if (state.selectedPlaces.length == 0) {
        filteredByPlaces = state.allJobs;
      } else {
        state.selectedPlaces.forEach(place => {
          filteredByPlaces = filteredByPlaces.concat(
            state.allJobs.filter(job => job.Place == place)
          );
        });
      }
      return filteredByPlaces;
    },
    /**
     *   Returns an array of regions and their places.
      1. Make an object with a region and it's places (regionPlaces)
      2. For each region, filter a list of jobs that have that region. (jobsFilteredByRegion)
        3. For each job, take all places in jobsFilteredByRegion
        4. Put those places in a Set (unique values) and put in the regionPlaces.places property
        5. put the regionPlaces object in the regionsPlaces Array
      6. return regionsPlaces
     */
    regionsPlaces: (state, getters) => {
      let regions = getters.regions;
      let regionsPlaces = [];
      regions.forEach(region => {
        let regionPlaces = { region: region, places: [] };
        let jobsFilteredByRegion = state.allJobs.filter(
          job => job.Region == region
        );
        jobsFilteredByRegion.forEach(job => {
          regionPlaces.places.push(job.Place);
        });

        regionPlaces.places.sort();
        regionPlaces.places = [...new Set(regionPlaces.places)];
        regionsPlaces.push(regionPlaces);
      });
      return regionsPlaces;
    },
    regionsPlacesOptions: (state, getters) => {
      let regionsPlacesOptions = [];
      getters.regionsPlaces.forEach(regionPlaces => {
        let regionPlacesOption = { region: {}, places: [] };
        regionPlacesOption.places = getPlacesOptions(
          regionPlaces.places,
          state.selectedPlaces
        );
        regionPlacesOption.region = getRegionOption(
          state,
          regionPlaces.region,
          regionPlacesOption.places
        );
        regionsPlacesOptions.push(regionPlacesOption);
      });

      return regionsPlacesOptions;

      function getPlacesOptions(placesJobs, selectedPlaces) {
        let placeOptions = [];
        placesJobs.forEach(place => {
          let placeOption = {
            value: "",
            text: "",
            disabled: false,
            selected: false,
            count: 0
          };

          var countInNotFilteredByPlaces = 0;
          for (var i = 0; i < getters.notFilteredByPlaces.length; ++i) {
            if (getters.notFilteredByPlaces[i].Place == place) {
              countInNotFilteredByPlaces++;
            }
          }
          placeOption.value = place;
          placeOption.text = place;
          placeOption.count = countInNotFilteredByPlaces;
          if (placeOption.count == 0) {
            placeOption.disabled = true;
          }
          if (selectedPlaces.includes(placeOption.value)) {
            placeOption.selected = true;
          }
          placeOptions.push(placeOption);
        });
        return placeOptions;
      }

      function getRegionOption(state, region, placesOptions) {
        // count is afhankelijk van hoeveel jobs
        // in de region
        let placesCount = countPlaces(placesOptions);
        let selectionState = getSelectionState(placesOptions);
        let regionOption = {
          value: region,
          text: region,
          disabled: false,
          collapsed: state.collapsedRegions.includes(region) ? true : false,
          placesCount: placesCount.total,
          selectedPlacesCount: placesCount.selected,
          indeterminate: selectionState.indeterminate,
          allSelected: selectionState.allSelected
        };

        function countPlaces(placesOptions) {
          let placesCount = { total: 0, selected: 0 };
          placesOptions.forEach(placeOption => {
            placesCount.total += placeOption.count;
            if (placeOption.selected) {
              placesCount.selected += placeOption.count;
            }
          });
          return placesCount;
        }

        function getSelectionState(placesOptions) {
          let selectionState = { indeterminate: false, allSelected: true };

          placesOptions.forEach(placeOption => {
            if (placeOption.selected == true) {
              selectionState.indeterminate = true;
            }
          });

          placesOptions.forEach(placeOption => {
            if (placeOption.selected == false) {
              selectionState.allSelected = false;
            }
          });

          if (selectionState.allSelected == true) {
            selectionState.indeterminate = false;
          }
          return selectionState;
        }
        return regionOption;
      }
    },
    // regionsPlacesOptions2: (state, getters) => {
    //   // Gewoon hetzelfde doen maar dan eerst voor regions en dan daarbinnen een loop voor places.
    //   // En dan die placeOption toevoegen aan de array van region
    //   let regionsPlacesOptions = [
    //     [
    //       [
    //         {
    //           value: "Noord-Holland",
    //           text: "Noord-Holland",
    //           selected: true,
    //           disabled: false,
    //           count: 5
    //         }
    //       ],
    //       [
    //         {
    //           value: "Amsterdam",
    //           text: "Amsterdam",
    //           disabled: false,
    //           count: 2
    //         },
    //         {
    //           value: "Hilversum",
    //           text: "Hilversum",
    //           disabled: false,
    //           count: 3
    //         }
    //       ]
    //     ],
    //     [
    //       [
    //         {
    //           value: "Utrecht",
    //           text: "Utrecht",
    //           disabled: false,
    //           count: 5
    //         }
    //       ],
    //       [
    //         {
    //           value: "Leerdam",
    //           text: "Leerdam",
    //           disabled: false,
    //           count: 2
    //         },
    //         {
    //           value: "Houten",
    //           text: "Houten",
    //           disabled: false,
    //           count: 3
    //         }
    //       ]
    //     ]
    //   ];
    //   return regionsPlacesOptions;
    // },

    // regionsPlacesOptions3: (state, getters) => {
    //   // Gewoon hetzelfde doen maar dan eerst voor regions en dan daarbinnen een loop voor places.
    //   // En dan die placeOption toevoegen aan de array van region
    //   let regionsPlacesOptionsObject = [
    //     {
    //       region: {
    //         value: "Noord-Holland",
    //         text: "Noord-Holland",
    //         selected: true,
    //         disabled: false,
    //         count: 5
    //       },
    //       places: [
    //         {
    //           value: "Hilversum",
    //           text: "Hilversum",
    //           disabled: false,
    //           count: 3
    //         },
    //         {
    //           value: "Amsterdam",
    //           text: "Amsterdam",
    //           disabled: false,
    //           count: 2
    //         }
    //       ]
    //     },
    //     {
    //       region: {
    //         value: "Utrecht",
    //         text: "Utrecht",
    //         disabled: false,
    //         count: 5
    //       },
    //       places: [
    //         {
    //           value: "Leerdam",
    //           text: "Leerdam",
    //           disabled: false,
    //           count: 2
    //         },
    //         {
    //           value: "Houten",
    //           text: "Houten",
    //           disabled: false,
    //           count: 3
    //         }
    //       ]
    //     }
    //   ];
    //   let regionsPlacesOptions = [
    //     [
    //       [
    //         {
    //           value: "Noord-Holland",
    //           text: "Noord-Holland",
    //           selected: true,
    //           disabled: false,
    //           count: 5
    //         }
    //       ],
    //       [
    //         {
    //           value: "Amsterdam",
    //           text: "Amsterdam",
    //           disabled: false,
    //           count: 2
    //         },
    //         {
    //           value: "Hilversum",
    //           text: "Hilversum",
    //           disabled: false,
    //           count: 3
    //         }
    //       ]
    //     ],
    //     [
    //       [
    //         {
    //           value: "Utrecht",
    //           text: "Utrecht",
    //           disabled: false,
    //           count: 5
    //         }
    //       ],
    //       [
    //         {
    //           value: "Leerdam",
    //           text: "Leerdam",
    //           disabled: false,
    //           count: 2
    //         },
    //         {
    //           value: "Houten",
    //           text: "Houten",
    //           disabled: false,
    //           count: 3
    //         }
    //       ]
    //     ]
    //   ];
    //   return regionsPlacesOptionsObject;
    // },

    notFilteredByPlaces(state, getters) {
      let notFilteredByPlaces;
      let array1 = getters.filteredByIndustries;
      let array2 = getters.filteredByContractTypes;
      let array3 = getters.filteredByEducationLevels;
      notFilteredByPlaces = array1.filter(function(n) {
        for (var i = 0; i < array2.length; i++) {
          if (n.Id == array2[i].Id) {
            return true;
          }
        }
        return false;
      });
      notFilteredByPlaces = notFilteredByPlaces.filter(function(n) {
        for (var i = 0; i < array3.length; i++) {
          if (n.Id == array3[i].Id) {
            return true;
          }
        }
        return false;
      });
      return notFilteredByPlaces;
    },
    // #region filter by's

    /*
    Take every job from filteredJobs and use the filter() method on the array to
    see if the property of the job matches or otherwise satisfies the selected filter.
    If not then the job will be popped off the filteredJobs array by the filter() method.
    */

    // #endregion
    /**
     * returns a list of jobs that match the selected filters
     * Assigns state.jobs (all jobs) to let = filteredJobs.
     * filteredJobs is then filtered by all selected filters.
     */
    filteredJobs: (state, getters) => {
      let filteredJobs;
      let array1 = getters.filteredByContractTypes;
      let array2 = getters.filteredByIndustries;
      let array3 = getters.filteredByEducationLevels;
      let array4 = getters.filteredByPlaces;

      //pak alle contractType en kijk welke daarvan
      filteredJobs = array1.filter(function(n) {
        for (var i = 0; i < array2.length; i++) {
          if (n.Id == array2[i].Id) {
            return true;
          }
        }
        return false;
      });

      filteredJobs = filteredJobs.filter(function(n) {
        for (var i = 0; i < array3.length; i++) {
          if (n.Id == array3[i].Id) {
            return true;
          }
        }
        return false;
      });

      filteredJobs = filteredJobs.filter(function(n) {
        for (var i = 0; i < array4.length; i++) {
          if (n.Id == array4[i].Id) {
            return true;
          }
        }
        return false;
      });

      // Newest first
      if (state.sortBy == state.sortOptions[0]) {
        filteredJobs = filteredJobs.sort((a, b) => (a.Id < b.Id ? 1 : -1));
      }

      // Oldest first
      if (state.sortBy == state.sortOptions[1]) {
        filteredJobs = filteredJobs.sort((a, b) => (a.Id > b.Id ? 1 : -1));
      }
      return filteredJobs;
    },

    slicedFilteredJobs: (state, getters) => {
      return getters.filteredJobs;
    },
    unFilteredJobs: (state, getters) => {}
  }
});
